<template>
  <MoreOptionsMenuButton
    v-bind="attrs"
    v-if="
      currentUser?.hasPermission('fleet.change_vehiclemake') ||
      currentUser?.hasPermission('fleet.delete_vehiclemake')
    "
  >
    <v-list-item
      v-if="currentUser.hasPermission('fleet.change_vehiclemake')"
      @click="emit('vehicle-make-edit-pressed', vehicleMake)"
      title="Edit vehicle make"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-pencil" class="me-1" />
      </template>
    </v-list-item>

    <template v-if="currentUser.hasPermission('fleet.delete_vehiclemake')">
      <v-divider class="pb-1" />
      <v-list-item
        class="text-error"
        @click="emit('vehicle-make-delete-pressed', vehicleMake)"
        title="Delete vehicle make"
      >
        <template #prepend>
          <v-icon size="18" icon="mdi-delete" class="me-1" />
        </template>
      </v-list-item>
    </template>
  </MoreOptionsMenuButton>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { storeToRefs } from 'pinia'

import type { IVehicleMake } from '@/models/fleet-management'

import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'

interface Props {
  vehicleMake: IVehicleMake
}
defineProps<Props>()

interface Emit {
  (e: 'vehicle-make-edit-pressed', vehicle: IVehicleMake): void
  (e: 'vehicle-make-delete-pressed', vehicle: IVehicleMake): void
}

const emit = defineEmits<Emit>()

const attrs = useAttrs()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
